import { throttle } from 'lodash';

const updateScrollIndicator = (sliderElement, progressElement, indicator) => {
  const scrollPos = sliderElement.scrollLeft;
  const width = sliderElement.scrollWidth - sliderElement.clientWidth;
  const scrolled = (scrollPos / width) * 100;
  const fraction = progressElement.offsetWidth / indicator.offsetWidth;
  const translateVal = scrolled * (fraction - 1);

  indicator.style.transform = `translateX(${translateVal}%)`;
};

export default (
  scrollElement:HTMLElement,
  scrollbar:HTMLElement,
  scrollIndicator:HTMLElement,
) => {
  scrollElement.addEventListener('scroll', throttle(() => {
    updateScrollIndicator(scrollElement, scrollbar, scrollIndicator);
  }, 10));
};
